import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, MapPin, BadgeCheck } from "lucide-react";
import { Layout, PageHeader } from "../components/Layout";
import api from "../lib/api";

const TIER = {
  featured: "bg-eon-gold text-white", pro: "bg-yellow-900/40 text-yellow-300 border border-yellow-700/40",
  verified: "bg-eon-elevated text-eon-gold border border-eon-border", free: "bg-eon-elevated text-eon-muted border border-eon-border",
};

export default function Breeders() {
  const [breeders, setBreeders] = useState([]);
  useEffect(() => { api.get("/breeders").then((r) => setBreeders(r.data)); }, []);
  return (
    <Layout>
      <PageHeader label="Boerboel Breeder Directory" title="Approved Boerboel Breeders"
        subtitle="Every breeder is reviewed and approved by E.O.N. Browse by location and verification tier — Featured, Pro, Verified and Free." />
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {breeders.map((b, i) => (
            <Link key={b.id} to={`/breeders/${b.id}`} data-testid={`breeder-card-${b.id}`} className="eon-card group animate-fade-up" style={{ animationDelay: `${i * 40}ms` }}>
              <div className="relative aspect-[16/10] overflow-hidden">
                <img src={b.image} alt={b.business_name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-eon-bg to-transparent" />
                <span className={`absolute top-3 left-3 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 ${TIER[b.tier]}`}>{b.tier}</span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2">
                  <h3 className="font-display text-xl font-bold">{b.business_name}</h3>
                  {b.tier !== "free" && <BadgeCheck size={16} className="text-eon-gold" />}
                </div>
                <div className="flex items-center gap-3 mt-2 text-xs text-eon-muted">
                  <span className="flex items-center gap-1"><MapPin size={12} /> {b.location}</span>
                  {b.review_count > 0 && <span className="flex items-center gap-1"><Star size={12} className="text-eon-gold fill-eon-gold" /> {b.rating} ({b.review_count})</span>}
                </div>
                <p className="text-sm text-eon-text/70 mt-3 line-clamp-2">{b.about}</p>
                <div className="flex flex-wrap gap-2 mt-4">{b.breeds.map((br) => <span key={br} className="eon-label border border-eon-border px-2 py-1">{br}</span>)}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}
